<div class="bmc-job-settings">
  <div class="bmc-job-settings__top-section">
    <div class="bmc-job-settings__top-section__element">
      <h5 class="bz-font-weight--semibold">{{'GLOBAL.NAME' | translate}}</h5>
      <ng-container>
        <h5>{{currentJob.name}}</h5>
      </ng-container>      
    </div>

    <div class="bmc-job-settings__top-section__element bmc-job-settings__top-section__element--right">
      <h5 class="bz-font-weight--semibold">{{'JOBS.CREATION_DATE' | translate}}</h5>
  <h5>{{ currentJob.creationDate | showDateFormat:1 }}</h5>
    </div>
  </div>

  <div class="bmc-job-settings__top-section bmc-job-settings__top-section-second">
    <div class="bmc-job-settings__top-section__element">
      <h5 class="bz-font-weight--semibold">{{'JOBS.COLUMN_CASE_NUMBER' | translate}}</h5>
      <h5>{{currentJob.radNumber}}</h5>
    </div>

    <div class="bmc-job-settings__top-section__element bmc-job-settings__top-section__element--right">
      <h5 class="bz-font-weight--semibold">{{'JOBS.COLUMN_CASE_ID' | translate}}</h5>
      <h5>{{currentJob.idCase}}</h5>
    </div>
  </div>

  <div class="bmc-job-settings__middle-section">
    <div class="bmc-job-settings__middle-section__left">
      <h5 class="bz-font-weight--semibold">{{'GLOBAL.DESCRIPTION' | translate}}</h5>
      <ng-container >
        <h5 class="bmc-job-settings__middle-section__left__text">{{currentJob.description}}</h5>
      </ng-container>     
    </div>
  </div>
  <div class="bmc-job-settings__enable mt">
    <bzg-switch [(ngModel)]='currentJob.enabled' [disabled]="currentJob.disableEditJob === true"></bzg-switch>
    <h5 class="bmc-job-settings__enable__text">{{ 'GLOBAL.ENABLED' | translate}}</h5>
  </div>
  <div class="bmc-job-settings__date-section bz-space--stack-m" *ngIf="hiddenNextRunTime()">
    <h5 class="bz-font-weight--semibold">{{'JOBS.NEXT_RUN_TIME' | translate}}</h5>
    <div class="bmc-job-settings">
      <div class="bmc-job-settings__date-section__bottom">
        <bz-date-time-picker [currentDate]="jobStates[currentJob.id].nextRuntimeDate"
                             [dateMax]="dateMax"
                             [isDisabled]="currentJob.disableEditJob"
                             (valueChange)="onDateChange($event)">
        </bz-date-time-picker>
        <div class="bmc-job-settings__date-section__bottom">
          <bzg-button-primary [disabled]="currentJob.disableEditJob" (click)="setJobNow()">
            {{
'JOBS.SET_JOB_NOW' |
            translate
            }}
          </bzg-button-primary>
        </div>
      </div>
    </div>
  </div>
  <hr>
  <div class="" *ngIf="showReset">
    <h5 class="bz-font-weight--semibold">{{'JOBS.RESET_DEVELOP_TITLE' | translate}}</h5>
    <div class="bz-form-message__text">{{'JOBS.RESET_DEVELOP' | translate}} <a class="bmc-job-settings__reset--link"
        (click)="resetJob()">{{ 'GLOBAL.RESET' | translate}}</a>
    </div>
  </div>
</div>

<div class="bmc-job-settings__buttons bz-flex bz-flex--end">
  <bzg-button-secondary (click)="cancelChanges()">{{ 'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
  <bzg-button-primary class="bmc-job-settings__buttons--right" (click)="applyChanges()" [disabled]="applyDisabled || currentJob.disableEditJob">{{ 'GLOBAL.APPLY' | translate}}</bzg-button-primary>
</div>
